/* eslint-disable camelcase */
import { extend } from 'vee-validate';
import {
  required,
  max,
  numeric,
  min,
  alpha_spaces,
  confirmed,
} from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Masukkan {_field_}.',
});

extend('min', {
  ...min,
  params: ['length'],
  message: 'Minimal {length} karakter',
});

extend('max', {
  ...max,
  params: ['length'],
  message: 'Maksimal {length} karakter',
});

extend('numeric', {
  ...numeric,
  message: 'Hanya dapat diisi dengan angka',
});

extend('alpha_spaces', {
  ...alpha_spaces,
  message: 'Hanya dapat diisi dengan huruf dan spasi',
});

// Usage: `confirmed:<vid of the field it must match>`
extend('confirmed', {
  ...confirmed,
  message: '{_field_} tidak sama',
});
